import React from 'react';
import { Link } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import './appNav.css';

export default function BackNav({ to = '/library', label = 'Back to Library' }) {
  return (
    <nav className="app-back-nav" aria-label="Back navigation">
      <Link to={to} className="app-back-nav-btn">
        <IoArrowBack aria-hidden />
        <span>{label}</span>
      </Link>
    </nav>
  );
}
